import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import Footer from '../components/common/footer';
import articles from '../data/articles.js';
import './styles/article.css';
import INFO from '../data/user';

const Article = () => {
  const { shortName } = useParams();
  const article = articles.find((a) => a.shortName === shortName);

  if (!article) {
    return <Navigate to="/404" />;
  }

  return (
    <>
      <Helmet>
        <title>{`${article.title} | ${INFO.main.title}`}</title>
        <meta name="description" content={article.summary} />
        <link rel="canonical" href={`${INFO.socials.website}/articles/${article.shortName}`} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={`${article.title} | ${INFO.main.title}`} />
        <meta property="og:description" content={article.summary} />
        <meta property="og:url" content={`${INFO.socials.website}/articles/${article.shortName}`} />
        <meta property="og:image" content={`${INFO.socials.website}/homepage.jpg`} />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: article.title,
          description: article.summary,
          datePublished: new Date(article.date).toISOString(),
          author: { '@type': 'Person', name: 'Anna Veretynska' },
          publisher: {
            '@type': 'Organization',
            name: 'Pasmo The Beauty Lab',
            logo: { '@type': 'ImageObject', url: `${INFO.socials.website}/logo512.avif` },
          },
          mainEntityOfPage: `${INFO.socials.website}/articles/${article.shortName}`,
          image: `${INFO.socials.website}/homepage.jpg`,
        })}</script>
      </Helmet>
      <div className="page-content">
          <div className='content-wrapper'>
            <div className="article-container">
                <h1 className="article-title">{article.title}</h1>
                <h2 className='article-date'>{article.date}</h2>
                <ReactMarkdown className='article-content'>{article.content}</ReactMarkdown>
            </div>
            <div className="page-footer">
                <Footer />
            </div>
          </div>
      </div>
    </>
  );
};

export default Article; 